<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-chart-simple"></i>
    {{ texts.analysisRequested[language] }}
    <div scActivityBody>
        @if (comment) {
        <p class="analysis-comment">{{ comment }}</p>
        }
    </div>
</sc-activity-list-item>
